import ReactSession from "./reactSession";
import jwt_decode from "jwt-decode";

export default function getPermissions() {
	const permissions = ReactSession.get("token") && jwt_decode(ReactSession.get("token")).permissions;
	const permissionsArray = permissions && permissions.map(({ p }) => p);
	return permissionsArray;
}
